export default {
  app: {
    golf: {
      title: 'Informazioni sul campo',
      hasEVChargingPoint: 'Punto di ricarica EV',
      hasCaddieService: 'Servizio caddie',
      hasTrolley: 'Carrello',
      hasBuggy: 'Buggy',
      hasClubRental: 'Noleggio mazze',
      hasAcademy: 'Accademia',
      hasMarshal: 'Marshal',
      hasPGACertification: 'Certificazione PGA',
      hasTrainingArea: 'Area di allenamento',
      hasRestaurant: 'Ristorante',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Cani sul campo',
      numberOfHoles: 'Numero di buche',
    },
  },
};
